<app-header></app-header>
<div class="flex flex-wrap">
    <div class="w-full sm:w-8/12 mb-10">
      <div class="container mx-auto h-full sm:p-10">
        <nav class="flex px-4 justify-between items-center">
          <div class="text-4xl font-bold">
            Explora. Aprende. Crece<span class="text-vjblue">.</span>
          </div>
          <div>
            <img src="https://image.flaticon.com/icons/svg/497/497348.svg" alt="" class="w-8">
          </div>
        </nav>
        <header class="container px-4 lg:flex mt-10 items-center h-full lg:mt-0">
          <div class="w-full">
            <h1 class="text-4xl lg:text-6xl font-bold">VoyJaleas<span class="text-vjblue"> tu puente</span> a una Educación Europea Extraordinaria</h1>
            <div class="w-20 h-2 text-vjblue my-4"></div>
            <p class="text-xl mb-10">En VoyJaleas, entendemos que estudiar en Europa es más que una educación; es una experiencia de vida que moldea tu futuro. Con una amplia experiencia y una profunda comprensión de las necesidades de los estudiantes internacionales, te guiamos en cada paso hacia tu aventura educativa en Europa.</p>
            <button class="vjblue text-white text-2xl font-medium px-4 py-2 rounded shadow" (click)="goToCalendly()">Reservar videollamada GRATIS</button>
          </div>
        </header>
      </div>
    </div>
    <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/7efc6206-b61a-4aa6-50b2-69f05fbe7700/public" alt="Leafs" class="w-full h-48 object-cover sm:h-screen sm:w-4/12">
</div>

<!-- <app-testimonial-a></app-testimonial-a> -->
<!-- <app-page-title [pageTitleA]="'Casos de '" [pageTitleB]="'éxito'" [pageSubtitle]=""></app-page-title>
<app-testimonial-carousel></app-testimonial-carousel> -->
<!-- Photo by <a href="https://unsplash.com/@quique_olivar?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Quique Olivar</a> on <a href="https://unsplash.com/photos/brown-building-during-nighttime-CRMjqDZwxS4?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
<app-footer-landing></app-footer-landing>